import cn from 'classnames';
import { Icon } from '@nespresso-design-system/components';
import styles from './VertuoOversizedCapsuleCompatibilitySection.module.scss';
import useTranslations from '@/widgets/hooks/useTranslations';
import { hasOversizedCapsule } from '@/domain/Product';
import type { Product } from '@/domain/Product';

export type VertuoOversizedCapsuleCompatibilitySectionProps = {
  class?: string;
  product: Product;
};

export default function VertuoOversizedCapsuleCompatibilitySection({
  class: className,
  product
}: VertuoOversizedCapsuleCompatibilitySectionProps) {
  const { t } = useTranslations();
  const showCompatibilityNotice = hasOversizedCapsule(product.categories);

  if (!showCompatibilityNotice) {
    return null;
  }

  const vertuoOversizedCapsuleCompatibilityLabel = t(
    'productList.machineCompatibility.quickViewDrawer.vertuoOversizedCapsuleCompatibilityLabel'
  );
  const vertuoOversizedCapsuleCompatibilityDescription = t(
    'productList.machineCompatibility.quickViewDrawer.vertuoOversizedCapsuleCompatibility.descriptionText'
  );

  return (
    <section class={cn(styles.container, className)}>
      <Icon
        className={styles.icon}
        icon="24/symbol/status-alert"
        method="image"
      />
      <div class={styles.msgContainer}>
        {vertuoOversizedCapsuleCompatibilityLabel && (
          <p class={styles.title}>{vertuoOversizedCapsuleCompatibilityLabel}</p>
        )}
        {vertuoOversizedCapsuleCompatibilityDescription && (
          <p class={styles.description}>
            {vertuoOversizedCapsuleCompatibilityDescription}
          </p>
        )}
      </div>
    </section>
  );
}
